import { IKeHoachMonGhepCap } from "../../../model/respone/ke-hoach/IKeHoachMonGhepCap";
import { IKeHoachMonViewModel } from "../../../model/respone/ke-hoach/IKeHoachMonViewModel";

import { eReducerStatusBase } from "../eReducerStatusBase";
export enum eGhepCapStatusExtend {
    is_loading_kh = "is_loading_kh",
    is_completed_kh = "is_completed_kh",
}
export interface IKeHoachMonGhepCapFilterReducer {
    id_he: number,
    khoa_hoc: number,
    id_chuyen_nganh: number,
    id_nganh: number,
}
export interface IKeHoachMonGhepCapReducer {
    nam_hoc: string,
    hoc_ky: number,
    status: eReducerStatusBase | eGhepCapStatusExtend;
    ghepCaps: IKeHoachMonGhepCap[];
    ghepCapEditing?: IKeHoachMonGhepCap;
    isShowEditModal?: boolean;
    filter: IKeHoachMonGhepCapFilterReducer,
    keHoachMons: IKeHoachMonViewModel[];
    nhomLopIdsExpanded: number[]
}
